import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        settings: null,
        error: null,
        loading: true
      }
    };

    super('coupon', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.COUPON.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.COUPON.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = data?.list || [];
      this.state.list_all.settings = data?.settings || null;
      this.state.list_all.loading = false;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.COUPON.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error;
      this.state.list_all.list = [];
      this.state.list_all.settings = null;
    });
  }
}

export default Store;
// new Store();
